import PropTypes from "prop-types";
import Text from "components/Common/Text";
import { Hole } from "../Hole";

function Item({ type }) {
  const container = {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    marginTop: 5,
  };

  const types = {
    0: "Eagle",
    1: "Birdie",
    2: "Bogey",
    3: "D. Bogey",
  };

  const mockScore = {
    0: 2,
    1: 1,
    2: -1,
    3: -2,
  };

  return (
    <div style={container}>
      <div style={{ marginRight: 5 }}>
        {Hole(null, mockScore[type], false, false, false)}
      </div>
      <Text as="P1" style={{ color: "#8E9190" }}>
        - {types[type]}
      </Text>
    </div>
  );
}

Item.propTypes = {
  type: PropTypes.number.isRequired,
};

export default function ScorecardLegend({ skins, quota }) {
  const winHole = (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        padding: 2,
        marginTop: 3,
      }}
    >
      <div
        style={{
          height: 33,
          width: 33,
          backgroundColor: "rgba(10, 132, 255, 0.8)",
          marginRight: 6,
        }}
      />
      <Text as="P1" style={{ color: "#8E9191" }}>
        - Win {skins ? "skins" : "hole"}
      </Text>
    </div>
  );

  const stroke = (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        padding: 2,
        marginTop: 3,
      }}
    >
      <div
        style={{
          height: 33,
          width: 33,
          backgroundColor: "#f6f6f6",
          marginRight: 6,
          justifyContent: "center",
          alignItems: "center",
          display: "flex",
        }}
      >
        •
      </div>
      <Text as="P1" style={{ color: "#8E9191" }}>
        - Stroke
      </Text>
    </div>
  );

  return quota ? (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        // justifyContent: "space-between",
        alignItems: "flex-start",
        backgroundColor: "#fcfcfc",
        padding: "13px 42px",
        flexWrap: "wrap",
        margin: 10,
      }}
    >
      <Text as="P1" style={{ color: "#8E9191" }}>
        D. Bogey or worse = 0
      </Text>
      <Text as="P1" style={{ color: "#8E9191" }}>
        Bogey = 1
      </Text>
      <Text as="P1" style={{ color: "#8E9191" }}>
        Par = 2
      </Text>
      <Text as="P1" style={{ color: "#8E9191" }}>
        Birdie = 4
      </Text>
      <Text as="P1" style={{ color: "#8E9191" }}>
        Eagle = 8
      </Text>
      <Text as="P1" style={{ color: "#8E9191" }}>
        Better then Eagle = 10
      </Text>
    </div>
  ) : (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        backgroundColor: "#fcfcfc",
        padding: "13px 42px",
        flexWrap: "wrap",
        margin: 10,
      }}
    >
      <div>
        <Item type={0} />
        <Item type={1} />
      </div>
      <div>
        <Item type={2} />
        <Item type={3} />
      </div>
      <div>
        {quota && winHole}
        {stroke}
      </div>
    </div>
  );
}

ScorecardLegend.propTypes = {
  skins: PropTypes.bool,
  quota: PropTypes.bool,
};

ScorecardLegend.defaultProps = {
  skins: false,
  quota: false,
};
